import React from 'react';
import styled from 'styled-components';
import { FjFlexContainer } from 'components/primitives';

const TabsWrapper = styled.div`
  display: flex;
  padding-left: ${({ theme }) => theme.grid.units(0.5)};
  padding-right: ${({ theme }) => theme.grid.units(0.5)};
  background: linear-gradient(to right, ${({ theme }) => theme.gradients.tabBackground});
`;

const ContentContainer = styled(FjFlexContainer)`
  padding-left: ${({ theme }) => theme.grid.units(1)};
  padding-right: ${({ theme }) => theme.grid.units(1)};
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;

const Container = styled(FjFlexContainer)`
  flex-direction: column;
  height: 100%;
`;

interface TabsContainerProps {
  tabs: React.ReactNode;
  tabContent: React.ReactNode;
}

const TabsContainer = (props: TabsContainerProps): React.JSX.Element => (
  <Container>
    <TabsWrapper>{props.tabs}</TabsWrapper>
    <ContentContainer>{props.tabContent}</ContentContainer>
  </Container>
);

export default TabsContainer;
